module.exports = __webpack_public_path__ + "img/wealth_l.858524fe.svg";